import { getStartDocumentList } from 'src/functions/fileManagerMethods';

export function createFileList(
  inspectionRequired: boolean,
  showIdentityDocument: boolean,
  createdAt: string,
  IdSecondSide: boolean,
): string[] {
  const documentList = getStartDocumentList(createdAt);
  if (showIdentityDocument) {
    documentList.push('cedula');
  }
  if (IdSecondSide) {
    documentList.push('cedula-optional');
  }
  documentList.push(inspectionRequired ? 'inspectionReport' : 'proforma');
  documentList.push('quotation');
  return documentList;
}

export function getInitialFileList(): string[] {
  return [];
}

export function createIndividualFileList(
  fileName: string,
  IdSecondSide: boolean,
): string[] {
  const documentList = [];
  if (IdSecondSide && fileName === 'cedula') {
    documentList.push('cedula-optional');
  }
  return documentList;
}
